"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURLPathParams = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var PathParamMap = {
  teamId: ['team', 'teams'],
  eventId: ['event', 'events'],
  showId: ['show', 'shows'],
  broadcastId: ['broadcast', 'broadcasts']
};
var getURLPathParams = exports.getURLPathParams = function getURLPathParams() {
  var pathParams = {};
  var segments = window.location.pathname.split('/');
  Object.entries(PathParamMap).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      id = _ref2[0],
      idPaths = _ref2[1];
    var pathIndex = segments.findIndex(function (el) {
      return idPaths.includes(el);
    });
    if (pathIndex !== -1) {
      pathParams[id] = segments[pathIndex + 1];
    }
  });
  return pathParams;
};